'use client';

const MAX_TOAST_NOTIFICATIONS = 3;
export {
  MAX_TOAST_NOTIFICATIONS
};
